import { AlertCircleCheckIcon } from './AlertCircleCheckIcon';

/**
 * author: Austin Andrews
 * id 68F19F47-B38B-4370-B299-4EE2BF2619A5
 * name alert-circle-check
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-circle-check.svg
 * tags
 * - Alert / Error 
 */
export const AlertCircleSuccessIcon = AlertCircleCheckIcon;
export default AlertCircleSuccessIcon